export default "__VITE_ASSET__Croa6qfX__"